import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { caseTypes, firmInfo } from '../data/mockData';
import { ArrowRight } from 'lucide-react';

const CaseTypesPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-slate-50 via-white to-blue-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
              Our <span className="text-blue-900">Practice Areas</span>
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Over the past {firmInfo.yearsExperience} years, our attorneys have successfully handled{' '}
              <span className="text-blue-900 font-semibold">{firmInfo.casesHandled}</span> personal injury cases.
            </p>
          </div>
        </div>
      </section>

      {/* Case Types Grid */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {caseTypes.map((caseType) => (
              <Link
                key={caseType.id}
                to={`/case-types/${caseType.id}`}
                className="group relative overflow-hidden rounded-xl bg-white shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100"
              >
                {/* Image */}
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={caseType.image}
                    alt={caseType.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-gray-900/60 via-transparent to-transparent"></div>
                </div>

                {/* Content */}
                <div className="p-5">
                  <h3 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-blue-900 transition-colors">
                    {caseType.title}
                  </h3>
                  <p className="text-gray-600 text-sm line-clamp-3">
                    {caseType.description}
                  </p>
                  <div className="mt-4 flex items-center text-blue-900 text-sm font-medium">
                    Learn More <ArrowRight className="w-4 h-4 ml-2 transition-transform group-hover:translate-x-2" />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CaseTypesPage;
